<div class="content-wrapper">
    <div class="content-body">
        <section id="leadDetail">
            <div class="row">
                <div class="col-12">
                    <h2 class="mt-5px">
                        <i class="fas fa-arrow-left cursor-pointer mr-2" (click)="back()"></i>
                        Lead Detail
                    </h2>
                </div>
            </div>

            <div class="row mt-2" *ngIf="loading">
                <div class="col-12 text-center">
                    <i class="fas fa-spinner fa-pulse f_20"></i>
                </div>
            </div>

            <div class="row mt-2" *ngIf="!loading && !lead">
                <div class="col-12">
                    <div class="card text-center">
                        <h5 class="p-5">Lead not found</h5>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="!loading && lead">
                <!-- Lead information section -->
                <div class="row mt-2">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">Lead Information</h4>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Name - <h6 class="mt-1">{{lead?.name}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Contact - <h6 class="mt-1">{{lead?.contact}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        OTP - <h6 class="mt-1">
                                            <span class="badge badge-success" *ngIf="lead?.otp_verified === true">Verified</span>
                                            <span class="badge badge-danger" *ngIf="lead?.otp_verified === false">Not Verified</span>
                                            <span *ngIf="lead?.otp_verified !== true && lead?.otp_verified !== false">-</span>
                                        </h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Email - <h6 class="mt-1">{{lead?.email}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Course - <h6 class="mt-1">{{lead?.course?.course || lead?.course_name}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        University - <h6 class="mt-1">{{lead?.university?.name || '-'}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Status - <h6 class="mt-1">{{lead?.status}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Assigned Counsellor - <h6 class="mt-1">{{lead?.assigned?.name || 'Unassigned'}}</h6>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-xs-12 mt-1">
                                        Received On - <h6 class="mt-1">{{lead?.created_at | date}}</h6>
                                    </div>
                                    <div class="col-12 mt-1" *ngIf="lead?.message">
                                        Message - <h6 class="mt-1">{{lead?.message}}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
    </div>
</div>
